import { render, staticRenderFns } from "./BalanceAndTransactions.vue?vue&type=template&id=098c8168&scoped=true&"
import script from "./BalanceAndTransactions.vue?vue&type=script&lang=js&"
export * from "./BalanceAndTransactions.vue?vue&type=script&lang=js&"
import style0 from "./BalanceAndTransactions.vue?vue&type=style&index=0&id=098c8168&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "098c8168",
  null
  
)

export default component.exports